import { useQuery } from '@tanstack/react-query';
import { Navigate, useParams } from 'react-router-dom';

import Loading from '../../components/Loading';
import { fetchPatientRedirectData } from '../../services/patient';
import { getNameClickRoute } from '../../utils/actionRoutes';

const PatientRedirect = () => {
    const { id } = useParams<{ id: string }>();

    const { data, isError } = useQuery({
        queryKey: ['patient-redirect', id],
        queryFn: () => fetchPatientRedirectData(id!),
        enabled: !!id,
        retry: false
    });

    if (isError || !id) {
        return <Navigate to="/home" replace />;
    }

    if (!data) {
        return <Loading />;
    }

    const redirectPath = getNameClickRoute(data.requiredAction, id);

    return <Navigate to={redirectPath} replace />;
};

export default PatientRedirect;
